  <div class="drag-drop-area"  
  [ngClass]="{ 'bg-blur': load}" 
  (click)="onDragDropClick()" 
  (dragover)="onDragOver($event)" 
  (dragleave)="onDragLeave($event)" 
  (drop)="onDrop($event)">

  <div class="load-bluer" *ngIf="load">
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24"><path fill="var(--default-app)" d="M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></path></svg>
  </div>

  <ng-container *ngIf="!image && !imgUrl ">
    <i class="fi fi-rr-cloud-upload-alt"></i>
  </ng-container>

  <ng-container *ngIf="load">
    <img *ngIf="imageSrc" [src]="imageSrc" class="img-fluid" />
  </ng-container>

  <ng-container *ngIf="imgUrl && !load" >
    <img  
    [src]="'https://s3.eu-north-1.amazonaws.com/menuload.com' + imgUrl"
    loading="lazy"
    class="img-fluid"
    alt="image">
  </ng-container>

  <input type="file" class="form-control form-control-lg" id="image" (change)="onFileChange($event)" hidden>

</div>








<!-- 
<div class="drag-drop-area"
      (dragover)="onDragOver($event)" 
      (dragleave)="onDragLeave($event)" 
      (drop)="onDrop($event)">
    
      <div class="load-bluer position-absolute top-0 left-0 " *ngIf="load && !showImg">
        <app-spinner [loading]="load"></app-spinner>
      </div>
    
      <ng-container *ngIf="!image && !imgUrl " >

      </ng-container>

   
        <div *ngIf="showImg && load" [ngClass]="{ 'bg-blur': load}" >
          <img *ngIf="imageSrc" [src]="imageSrc" alt="{{ 'SELECTED_IMAGE' | translate }}" 
          class="img-fluid card-img-top rounded-start" [ngClass]="{ 'open-image': isOpen}">
        </div>
 
        <div *ngIf="showImg && imgUrl !== '' && !load" 
        >
          <div class="image-container"
              *ngIf="edit"
              (mousedown)="onMouseDown($event)"
              (mousemove)="onMouseMove($event)"
              (mouseup)="onMouseUp()">
              <img src="https://s3.eu-north-1.amazonaws.com/menuload.com{{imgUrl}}" 
                class="draggable-image" [ngClass]="{ 'open-image': isOpen}"  #image>
          </div>

          <img src="https://s3.eu-north-1.amazonaws.com/menuload.com{{imgUrl}}" 
            *ngIf="!edit"
            class="draggable-image" [ngClass]="{ 'open-image': isOpen}"  #image>

        </div>
     

      <ng-container *ngIf="!image && !showImg">
        <app-icon width="34" height="34" *ngIf="!load" [iconName]="'cloud-upload'"   (click)="onDragDropClick()"></app-icon>
      </ng-container>

      <input type="file" class="form-control form-control-lg" id="image" (change)="onFileChange($event)" hidden>
</div> -->



